import { CUSTOM_CLASS_NAME } from 'core/constants'
import { layoutSmall } from 'core/util/default'
import React from 'react'
import styled, { css } from 'styled-components'

interface SkeletonCurationProps {}

const SkeletonCuration: React.FC<SkeletonCurationProps> = (props) => {
  return (
    <StyledSkeletonCuration className={CUSTOM_CLASS_NAME.CURATION_CATEGORY_BUTTON_SKELETON}>
      <div className="curation_wrapper">
        <div className="skeleton curation_img" />
      </div>
      <div className="skeleton curation_title" />
    </StyledSkeletonCuration>
  )
}

const StyledSkeletonCuration = styled.a`
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }

  .skeleton {
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
  }
  .curation_img {
    width: 78px;
    height: 78px;
    border-radius: 50%;
  }
  .curation_title {
    margin-top: 8px;
    width: 78px;
    height: 18px;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.29;
    border-radius: 6px;
    text-align: center;
  }

  ${layoutSmall(css`
    .curation_img {
      width: 72px;
      height: 72px;
    }
    .curation_title {
      width: 72px;
    }
  `)}
`
export default SkeletonCuration
